import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import dayjs from 'dayjs';

import { useFormik } from 'formik';

import { useDispatch } from 'react-redux';
import { listProducts } from '../../modules/productModule/products';
import { ProductListBox } from '../../components/productmng/ProductListBox';

const ProductSearchContainer = ({ downloadExl, uploadExl }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleAdd = () => {
    navigate('/productmng/add');
  };

  const initialValues = {
    searchKeyword: 'productNm',
    searchWords: '',
  };

  const validationSchema = yup.object({
    searchKeyword: yup.string('').nullable(),
    searchWords: yup.string('').trim().nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);

      let searchData = {
        [values.searchKeyword]: values.searchWords,
      };

      setTimeout(() => {
        // alert(JSON.stringify(values, null, 2));
        dispatch(listProducts(searchData));
        // formik.resetForm();
        setSubmitting(false);
      }, 1000);
    },
  });

  const handleDownloadExl = () => {
    let searchData = {
      [formik.values.searchKeyword]: formik.values.searchWords,
    };
    downloadExl(searchData);
  };

  return (
    <ProductListBox
      formik={formik}
      handleAdd={handleAdd}
      downloadExl={handleDownloadExl}
      uploadExl={uploadExl}
    />
  );
};

export default ProductSearchContainer;
